// extracted by mini-css-extract-plugin
export var arrowUpAndDown = "PreviewLoadingScreen-module--arrow-up-and-down--d6725";
export var container = "PreviewLoadingScreen-module--container--72608";
export var contentContainer = "PreviewLoadingScreen-module--contentContainer--b9bed";
export var icon = "PreviewLoadingScreen-module--icon--f4b58";
export var rotate = "PreviewLoadingScreen-module--rotate--d2887";
export var title = "PreviewLoadingScreen-module--title--fc42d";